import axios from 'axios'

export const get_qiniu_token=(para)=>{
  return axios.get('/louguanjia-web/open/assistant/getQiniuToken',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
export const toQiniu=(para)=>{
  return axios.post('https://upload.qiniup.com/',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//登录
export const login=(para)=>{
  return axios.post('/louguanjia-web/open/login',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//发短信接口
export const sendSmsCode=(para)=>{
  return axios.post('/louguanjia-web/open/sendSmsCode',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//忘记密码接口
export const forgetPassword=(para)=>{
  return axios.post('/louguanjia-web/open/forgetPassword',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 获取区县下街镇接口
export const getTownsByArea = (para) => {
  return axios.get('/louguanjia-web/open/assistant/getTownsByArea', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
